import React, { ReactNode, useContext, useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import Chevron from '../../../components/Chevron'
import { ChevronType, Color, Direction } from '../../../utils/constants'
import { twMerge } from 'tailwind-merge'
import { Page } from '../../../pages'
import HeaderContext from './HeaderContext'
import { useLocation } from 'react-router-dom'
import Dropdown from '../../../components/Dropdown'

interface HeaderLinkProps {
  id: string
  value: Page[]
  renderPage: (page: Page, inDropdown: boolean, isMobile?: boolean) => ReactNode
  color: Color
  inDropdown?: boolean
}

const HeaderLink = ({ id, value, renderPage, color, inDropdown = false }: HeaderLinkProps) => {
    const location = useLocation()
    const { setIsHeaderHovered, isHeaderHovered } = useContext(HeaderContext)
    const [isHovered, setIsHovered] = useState(false)

    useEffect(() => {
        if (isHeaderHovered && value.length === 1) return
        setIsHeaderHovered(isHovered && value.length > 1)
    }, [isHovered, setIsHeaderHovered, isHeaderHovered, value.length])

    useEffect(() => {
        setIsHovered(false)
        setIsHeaderHovered(false)
    }, [location.pathname, setIsHeaderHovered])

    return (
        <div
            className={twMerge('relative', isHovered ? 'z-50' : 'z-30')}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className='flex items-center relative w-max'>
                {value.length === 1 ? (
                    renderPage(value[0], inDropdown)
                ) : (
                    <>
                        <FormattedMessage id={id}>
                            {(value) => <span className='header-link'>{value}</span>}
                        </FormattedMessage>
                        <Chevron
                            direction={Direction.DOWN}
                            className={twMerge('w-3 ml-1')}
                            type={ChevronType.FULL}
                        />
                    </>
                )}
                {!inDropdown && (
                    <div
                        style={{ width: isHovered ? '100%' : '0' }}
                        className={twMerge(
                            'h-0.5 absolute -bottom-0.5 transition-width transition-200 ease-out',
                            color === Color.BLACK ? 'bg-black' : 'bg-white',
                        )}
                    />
                )}
            </div>
            {isHovered && value.length > 1 && (
                <Dropdown className='left-1/2 pt-2 md:-translate-x-1/2 ml-6'>
                    {value.map((page) => (
                        <HeaderLink
                            color={Color.BLACK}
                            key={page.title}
                            id={id}
                            renderPage={renderPage}
                            value={[page]}
                            inDropdown
                        />
                    ))}
                </Dropdown>
            )}
        </div>
    )
}

export default HeaderLink
